import React from 'react';
import BaseModal from 'src/common/components/Modal';

const DeleteConsultModal = ({ open, setClose, onDelete }) => {
	return (
		<BaseModal
			open={open}
			mainText="Eliminar Resolución"
			confirmLabel="Si, eliminar"
			onConfirm={onDelete}
			onClose={() => setClose(false)}
			onCancel={() => setClose(false)}
		>
			<h5 className="text-center">
				¿Seguro que desea eliminar esta resolución/recomendación?
			</h5>
		</BaseModal>
	);
};

export default DeleteConsultModal;
